<ng-content tabindex="-1"></ng-content>
